import { organizationBillAddresses } from 'locales/ja/organization_bill_addresses';
import type { PageType } from 'types/page_type';

export const organizationBillAddressesNewPage: Readonly<PageType> = {
  path: '/organization_bill_addresses/new',
  title: `${organizationBillAddresses.resourceName} 登録`,
  description: `${organizationBillAddresses.resourceName}の登録`,
};

export const organizationBillAddressesEditPage: Readonly<PageType> = {
  path: '/organization_bill_addresses/edit',
  title: `${organizationBillAddresses.resourceName} 編集`,
  description: `${organizationBillAddresses.resourceName}の編集`,
};
